import { LOGIN_ERROR, LOGIN_SUCCESS, LOGOUT_SUCCESS } from '../constants/auth';
import history from '../history';
import Cookies from 'js-cookie';

import { updateUser, connectUser, resetUserPassword } from '../api/auth';

import {
  destroyAuthTokenAsClient,
  getAuthTokenAsClient,
  logAsClient
} from './connectAsClient';
import { setLocale } from 'react-redux-i18n';
import get from 'lodash/get';
import moment from 'moment';

const COOKIE_KEY = 'wineservices:authtoken';

export const getAuthToken = () => {
  let authToken = Cookies.get(COOKIE_KEY);

  let oldAuthToken = localStorage.getItem(COOKIE_KEY);
  if (oldAuthToken) {
    if (!authToken) authToken = oldAuthToken;
    localStorage.removeItem(COOKIE_KEY);
  }

  if (authToken) {
    authToken = authToken.replace(/"/g, '');
    setAuthToken(authToken);
    return authToken;
  } else {
    return null;
  }
};

export const setAuthToken = async (data) =>
  await Cookies.set(COOKIE_KEY, JSON.stringify(data), { expires: 360 });

export const destroyAuthToken = () => {
  Cookies.remove(COOKIE_KEY);

  let oldAuthToken = localStorage.getItem(COOKIE_KEY);
  if (oldAuthToken) {
    localStorage.removeItem(COOKIE_KEY);
  }
};

export const getLanguageUser = (userInfo) => {
  if (get(userInfo, 'language')) {
    return get(userInfo, 'language');
  }
  if (get(userInfo, 'client.language')) {
    return get(userInfo, 'client.language');
  }
  return 'fr';
};

/**
 * set language and moment
 *
 * @param {*} language example object : language 'fr', 'en', 'it'
 * @returns promise
 */
export const setLanguageLocale = (language) => async (dispatch) => {
  // Posthog deactivated for now
  //posthog.identify(`${userInfo.first_name} ${userInfo.last_name}`);
  moment.locale(language);
  dispatch(setLocale(language));
};

/**
 *
 * @param {*} authData example object : {username:"email@email.com",password:"djaioa48=)"}
 * @returns promise
 */
export const onLogin = (authData) => async (dispatch) => {
  const responseLogin = await connectUser(authData);
  if (!responseLogin) {
    destroyAuthToken();
    dispatch({ type: LOGIN_ERROR });
    return;
  }

  const token = responseLogin.token;
  await setAuthToken(token);

  dispatch({
    type: LOGIN_SUCCESS,
    payload: { token }
  });
  history.push('/dashboard');
};

export const onAutoLogin = () => async (dispatch) => {
  let token = await getAuthToken();
  if (!token) {
    destroyAuthToken();
    dispatch({ type: LOGIN_ERROR });
    return;
  }

  let tokenAsClient = getAuthTokenAsClient();
  if (!window.location.pathname.startsWith('/connect') && tokenAsClient) {
    logAsClient(tokenAsClient)(dispatch);
  }

  dispatch({
    type: LOGIN_SUCCESS,
    payload: { token }
  });

  if (window.location.pathname === '/') {
    history.replace('/dashboard');
  }
};

export const onLogout = () => {
  return (dispatch) => {
    destroyAuthTokenAsClient();
    destroyAuthToken();
    dispatch({ type: LOGOUT_SUCCESS });
    history.push('/');
  };
};

export const patchUser = (data) => async () => {
  await updateUser(data);
};

export const resetPassword = (data) => async () => {
  await resetUserPassword(data);
};
